import React from 'react';
import {IBorderRadius} from './borderRadius';

export enum ShadowType {
    NONE,
    SMALL,
    MEDIUM,
    LARGE,
}

function getRoundedBoxStyle(borderRadius?: IBorderRadius): React.CSSProperties {
    const hasRadius = Boolean(borderRadius?.upperLeft || borderRadius?.upperRight || borderRadius?.lowerLeft || borderRadius?.lowerRight);

    if (!borderRadius || !hasRadius) {
        return {};
    }

    return {
        borderRadius: `${borderRadius.upperLeft || 0}em ${borderRadius.upperRight || 0}em ${borderRadius.lowerRight || 0}em ${
            borderRadius.lowerLeft || 0
        }em`,
    };
}

export function getElementShadow(type?: ShadowType, borderRadius?: IBorderRadius, backgroundColor?: string): React.CSSProperties {
    const shape = getRoundedBoxStyle(borderRadius);
    const background = backgroundColor ? {backgroundColor} : {};

    switch (type) {
        case ShadowType.NONE:
            return {};
        case ShadowType.SMALL:
            return {
                ...shape,
                ...background,
                boxShadow: '0 0.0625em 0.1875em 0 rgb(0 0 0 / 0.1), 0 0.0625em 0.125em -0.0625em rgb(0 0 0 / 0.1)',
            };
        case ShadowType.MEDIUM:
            return {
                ...shape,
                ...background,
                boxShadow: '0 0.25em 0.375em -0.0625em rgb(0 0 0 / 0.1), 0 0.125em 0.25em -0.125em rgb(0 0 0 / 0.1)',
            };
        case ShadowType.LARGE:
            return {
                ...shape,
                ...background,
                boxShadow: '0 0.625em 0.9375em -0.1875em rgb(0 0 0 / 0.1), 0 0.25em 0.375em -0.25em rgb(0 0 0 / 0.1)',
            };
        default:
            return {};
    }
}
